import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { addressSelector } from 'shared/selectors';
import { IAddressInfo } from 'shared/types/geo/address';

const MOSCOW_CITY_ID = 1;

export function useRegion() {
  const addresses = useSelector(addressSelector);

  let region: IAddressInfo | undefined;

  region = addresses.find(item => item.locationTypeId === 1);

  if (!region) {
    region = addresses.find(item => item.locationTypeId === 2);
  }

  return useMemo(() => {
    if (region) {
      return {
        id: region.id,
        displayName: region.fullName,
      };
    }

    return {
      id: MOSCOW_CITY_ID,
    };
  }, [region]);
}
